/**
 * QapaqLogo — Logotipo oficial QAPAQ (vectores reales)
 *
 * Props:
 *   variant: 'isotipo' | 'full'
 *     - 'isotipo' : solo el símbolo Q-ring (sidebar, favicon)
 *     - 'full'    : símbolo + banner "QAPAQ" (login, registro)
 *   size: número — ancho en px (alto se ajusta automáticamente)
 */
export function QapaqLogo({ variant = 'isotipo', size = 48 }) {
  if (variant === 'full') {
    // Logo completo: proporción aprox 3:4 (isotipo cuadrado + banner texto)
    const h = Math.round(size * 1.33)
    return (
      <img
        src="/qapaq-logo.jpg"
        alt="QAPAQ logotipo"
        width={size}
        height={h}
        style={{ display: 'block', objectFit: 'contain' }}
        draggable={false}
      />
    )
  }

  // variant === 'isotipo' — solo el Q circular (cuadrado 1:1)
  return (
    <img
      src="/qapaq-icon.png"
      alt="QAPAQ isotipo"
      width={size}
      height={size}
      style={{ display: 'block', objectFit: 'contain' }}
      draggable={false}
    />
  )
}
